export default class Mixins {
  triggerClickByEnter(e) {
    if (e.keyCode === 13) {
      e.preventDefault()
      e.stopPropagation()
      e.target.click()
    }
  }
}
